export const zoomLevels = ['DAYS', 'WEEKS', 'MONTHS', 'QUARTERS', 'YEARS'];
export const GANTT_STYLE_MODE = {
  BARS: 'bars',
  BLOCKS: 'blocks'
};
